"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyStrict = exports.copy = void 0;
const copy = (obj) => {
    if (!obj) {
        return undefined;
    }
    return JSON.parse(JSON.stringify(obj));
};
exports.copy = copy;
const copyStrict = (obj) => {
    return JSON.parse(JSON.stringify(obj));
};
exports.copyStrict = copyStrict;
//# sourceMappingURL=copy.js.map